/**
 * AutoImporting components
 * @param path
 * @returns {function(): *}
 */
const page = path => () =>
    import(/* webpackChunkName: '' */ `./components/${path}`).then(
        m => m.default || m
    );

export const routes = [
    {
        path: "/configuracion/articulos",
        name: "Artículos",
        component: page("ArticleList")
    },
    {
        path: "/configuracion/articulos/:id",
        name: "Artículo",
        component: page("ArticleView")
    }
];
